import React from 'react';
import { IonIcon } from '@ionic/react';
import { NavLink, useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import './MobileHeader.scss';

import { ALLOW_CASINO } from '../../../constants/CasinoPermission';
import { CONFIG_PERMISSIONS } from '../../../constants/ConfigPermission';
import { RootState } from '../../../models/RootState';
import { ReactComponent as SportsImg } from '../../../assets/images/sportsbook/icons/sports.svg';
import { ReactComponent as CasinoImg } from '../../../assets/images/sportsbook/icons/casino.svg';
import { ReactComponent as InplayImg } from '../../../assets/images/sportsbook/icons/inplay-mob.svg';
import { ReactComponent as MyBetsImg } from '../../../assets/images/icons/my-bets.svg';
import { ReactComponent as ProfileImg} from '../../../assets/images/icons/user.svg';
import { ReactComponent as HomeImg } from '../../../assets/images/sportsbook/icons/home.svg';
import { useDomainConfigHook } from '../../../hooks/domainConfigHook';
import { checkForDomainConfig } from '../../../util/domainConfigUtils';

type StoreProps = {
  allowedConfig: number;
};

const MobileHeader: React.FC<StoreProps> = (props) => {
  const { allowedConfig } = props;
  const path = useHistory();
  const pathName = path.location.pathname;

  const { showCasinoComponents, showSportsComponents } = useDomainConfigHook();

  return (
    <>
    {
      path.location.pathname.includes('/dc/gamev1.1/') ? null :
    <div className="exch-mob-header-ctn">
        {checkForDomainConfig(CONFIG_PERMISSIONS.sports, showSportsComponents, showCasinoComponents) ? (
        <>
          <NavLink
            activeClassName="active"
            to="/exchange_sports/inplay"
            className="exch-mob-nav-link mob-link-btn"
          >
            <div className="exch-nav-item-ctn">
              <div className = "exch-nav-item-icon inplay-icon"><InplayImg /></div>
              <div className="exch-nav-item-label">In Play</div>
            </div>
          </NavLink>
          <NavLink
            activeClassName={
              !pathName.endsWith('/inplay') && !pathName.endsWith('/binary')
                ? 'active'
                : null
            }
            to="/exchange_sports"
            className="exch-mob-nav-link  mob-link-btn"
          >
            <div className="exch-nav-item-ctn">
              <div className = "exch-nav-item-icon sport-icon"><SportsImg /></div>
              <div className="exch-nav-item-label">Sports</div>
            </div>
          </NavLink>
        </>
      ) : ALLOW_CASINO ? (
        <NavLink
          activeClassName={"active"}
          to="/casino"
          className={'exch-mob-nav-link mob-link-btn'}
        >
          <div className="exch-nav-item-ctn">
            <div className = "exch-nav-item-icon casino-icon"  ><CasinoImg /></div>
            <div className="exch-nav-item-label casino-label">Casino</div>
          </div>
        </NavLink>
      ) : (
        <div className={'exch-mob-nav-link  mob-link-btn disabled'}>
          <div className="exch-nav-item-ctn">
            <div className = "exch-nav-item-icon casino-icon"  ><CasinoImg /></div>
            <div className="exch-nav-item-label casino-label">Casino</div>
          </div>
        </div>
      )}

      <NavLink
        activeClassName="active"
        to="/home"
        className="exch-mob-nav-link mob-link-btn"
      >
        <div className="exch-nav-item-ctn">
          <div className = "exch-nav-item-icon home-icon"><HomeImg /></div>
          <div className="exch-nav-item-label">Home</div>
        </div>
      </NavLink>

      {checkForDomainConfig(CONFIG_PERMISSIONS.casino, showSportsComponents, showCasinoComponents) &&
      ![8, 16, 24].includes(allowedConfig) ? (
        ALLOW_CASINO ? (
          <NavLink
            activeClassName="active"
            to="/casino"
            className={pathName.includes('/dc/gamev1.1/')? 'active exch-mob-nav-link mob-link-btn': 'exch-mob-nav-link mob-link-btn'}
          >
            <div className="exch-nav-item-ctn">
              <div className = "exch-nav-item-icon casino-icon"><CasinoImg /></div>
              <div className="exch-nav-item-label casino-label">Casino</div>
            </div>
          </NavLink>
        ) : (
          <div className={'exch-mob-nav-link  mob-link-btn disabled'}>
            <div className="exch-nav-item-ctn">
              <div className = "exch-nav-item-icon casino-icon"><CasinoImg /></div>
              <div className="exch-nav-item-label casino-label">Casino</div>
            </div>
          </div>
        )
      ) : checkForDomainConfig(CONFIG_PERMISSIONS.sports, showSportsComponents, showCasinoComponents)? (
        <NavLink
          activeClassName="active"
          to="/my_bets"
          className="exch-mob-nav-link  mob-link-btn"
        >
          <div className="exch-nav-item-ctn">
            <div className = "exch-nav-item-icon profile-icon"><MyBetsImg /></div>
            <div className="exch-nav-item-label">My Bets</div>
          </div>
        </NavLink>
      ) : null}

      <NavLink
        activeClassName="active"
        to="/dashboard"
        className="exch-mob-nav-link  mob-link-btn"
      >
        <div className="exch-nav-item-ctn">
          <div className = "exch-nav-item-icon profile-icon" ><ProfileImg /></div>
          <div className="exch-nav-item-label">Profile</div>
        </div>
      </NavLink>
    </div>}
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    allowedConfig: state.common.allowedConfig,
  };
};

export default connect(mapStateToProps)(MobileHeader);
